module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/favicon_urb.8483084a.svg";